<template lang="pug">
  apollo-query(
    :query="query"
    :variables="variables"
    :fetchPolicy="fetchPolicy"
    tag=""
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data }, query }")
      slot(:coach="coach" :query="query") Implement required
</template>

<script>
import { FETCH_COACH_QUERY } from '@/graphql'
import createCoach from '@/entities/Coach'

export default {
  props: {
    coachId: { type: String, required: true },
    countPerPage: { type: Number, default: 5 }, // reviews params
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_COACH_QUERY,
      coach: {},
      pageInfo: {},
    }
  },
  computed: {
    variables() {
      return {
        id: this.coachId,
        first: this.countPerPage,
      }
    },
  },
  methods: {
    onResult(result) {
      const publicCoach = result?.data?.publicCoach
      if (publicCoach) {
        this.coach = createCoach(publicCoach)
        this.$emit('onResult', this.coach)

        this.pageInfo = publicCoach?.reviewResult?.reviews?.pageInfo
        if (!this.pageInfo.hasNextPage) {
          this.$emit('nodata')
        }
      }
    },
    async loadMore(query) {
      await query.fetchMore({
        variables: {
          coachId: this.coachId,
          first: this.countPerPage,
          after: this.pageInfo.endCursor,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const coachesReviewsFetchMore =
            fetchMoreResult?.publicCoach?.reviewResult?.reviews || {}
          if (!fetchMoreResult || coachesReviewsFetchMore.edges.length === 0) {
            return previousResult
          }

          let result = previousResult
          let reviews = result?.publicCoach?.reviewResult?.reviews || {}
          let prevReviewEdges = reviews.edges || []
          reviews.edges = prevReviewEdges.concat(coachesReviewsFetchMore.edges)
          reviews.pageInfo = coachesReviewsFetchMore.pageInfo || {}
          result.publicCoach.reviewResult.reviews = reviews

          return result
        },
      })
    },
  },
}
</script>
